import { ReviewItem } from 'features/Home/components/ReviewsSection/ReviewsSection'
import Dog1 from '../../public/assets/recipes/categories/review-1.png'
import Dog2 from '../../public/assets/recipes/categories/review-2.png'
import Dog3 from '../../public/assets/recipes/categories/review-3.png'
import Dog4 from '../../public/assets/recipes/categories/review-4.png'
import Dog5 from '../../public/assets/recipes/categories/review-5.png'
import Dog6 from '../../public/assets/recipes/categories/review-6.png'
import Dog7 from '../../public/assets/recipes/categories/review-7.png'
import Dog8 from '../../public/assets/recipes/categories/review-8.png'
import Dog9 from '../../public/assets/recipes/categories/review-9.png'
import Dog10 from '../../public/assets/recipes/categories/review-10.png'
import Dog11 from '../../public/assets/recipes/categories/review-11.png'
import Dog12 from '../../public/assets/recipes/categories/review-12.png'
import Dog13 from '../../public/assets/recipes/categories/review-13.png'
import Dog14 from '../../public/assets/recipes/categories/review-14.png'
import Dog15 from '../../public/assets/recipes/categories/review-15.png'
import Dog16 from '../../public/assets/recipes/categories/review-16.png'
import Dog17 from '../../public/assets/recipes/categories/review-17.png'
import Dog18 from '../../public/assets/recipes/categories/review-18.png'
import Dog19 from '../../public/assets/recipes/categories/review-19.png'
import Dog20 from '../../public/assets/recipes/categories/review-20.png'
import Dog21 from '../../public/assets/recipes/categories/review-21.png'
import Dog22 from '../../public/assets/recipes/categories/review-22.png'
import Dog23 from '../../public/assets/recipes/categories/review-23.png'
import Dog24 from '../../public/assets/recipes/categories/review-24.png'
import { StaticImageData } from 'next/image'

export const DUMMY_REVIEWS: ReviewItem[] = [
  {
    name: 'John Doe',
    message: 'First review',
  },
  {
    name: 'Jane Doe',
    message: 'Second review',
  },
  {
    name: 'Jim Doe',
    message: 'Third review',
  },
]

export type ReviewType = {
  name: AuthorType
  owner: string
  comment: string
  image: StaticImageData
}

type AuthorType =
  | 'seth'
  | 'melissa'
  | 'mariah'
  | 'sunny'
  | 'julie'
  | 'cristin'
  | 'barbara'
  | 'autumn'
  | 'diana'
  | 'lori'
  | 'nena'
  | 'ashley'
  | 'rachel'
  | 'rebekah'
  | 'norman'
  | 'peter'
  | 'darlene'
  | 'jen'
  | 'mallia'
  | 'jev'
  | 'teresa'
  | 'anu'
  | 'katie'
  | 'valerie'

export const ReviewMap: { [key in AuthorType]: ReviewType } = {
  melissa: {
    name: 'melissa',
    owner: 'recipes:overview.reviews.review-1.owner',
    comment: 'recipes:overview.reviews.review-1.comment',
    image: Dog1,
  },
  mariah: {
    name: 'mariah',
    owner: 'recipes:overview.reviews.review-2.owner',
    comment: 'recipes:overview.reviews.review-2.comment',
    image: Dog2,
  },
  sunny: {
    name: 'sunny',
    owner: 'recipes:overview.reviews.review-3.owner',
    comment: 'recipes:overview.reviews.review-3.comment',
    image: Dog3,
  },
  julie: {
    name: 'julie',
    owner: 'recipes:overview.reviews.review-4.owner',
    comment: 'recipes:overview.reviews.review-4.comment',
    image: Dog4,
  },
  cristin: {
    name: 'cristin',
    owner: 'recipes:overview.reviews.review-5.owner',
    comment: 'recipes:overview.reviews.review-5.comment',
    image: Dog5,
  },
  barbara: {
    name: 'barbara',
    owner: 'recipes:overview.reviews.review-6.owner',
    comment: 'recipes:overview.reviews.review-6.comment',
    image: Dog6,
  },
  autumn: {
    name: 'autumn',
    owner: 'recipes:overview.reviews.review-7.owner',
    comment: 'recipes:overview.reviews.review-7.comment',
    image: Dog7,
  },
  diana: {
    name: 'diana',
    owner: 'recipes:overview.reviews.review-8.owner',
    comment: 'recipes:overview.reviews.review-8.comment',
    image: Dog8,
  },
  lori: {
    name: 'lori',
    owner: 'recipes:overview.reviews.review-9.owner',
    comment: 'recipes:overview.reviews.review-9.comment',
    image: Dog9,
  },
  nena: {
    name: 'nena',
    owner: 'recipes:overview.reviews.review-10.owner',
    comment: 'recipes:overview.reviews.review-10.comment',
    image: Dog10,
  },
  ashley: {
    name: 'ashley',
    owner: 'recipes:overview.reviews.review-11.owner',
    comment: 'recipes:overview.reviews.review-11.comment',
    image: Dog11,
  },
  rachel: {
    name: 'rachel',
    owner: 'recipes:overview.reviews.review-12.owner',
    comment: 'recipes:overview.reviews.review-12.comment',
    image: Dog12,
  },
  rebekah: {
    name: 'rebekah',
    owner: 'recipes:overview.reviews.review-13.owner',
    comment: 'recipes:overview.reviews.review-13.comment',
    image: Dog13,
  },
  seth: {
    name: 'seth',
    owner: 'recipes:overview.reviews.review-14.owner',
    comment: 'recipes:overview.reviews.review-14.comment',
    image: Dog14,
  },
  norman: {
    name: 'norman',
    owner: 'recipes:overview.reviews.review-15.owner',
    comment: 'recipes:overview.reviews.review-15.comment',
    image: Dog15,
  },
  peter: {
    name: 'peter',
    owner: 'recipes:overview.reviews.review-16.owner',
    comment: 'recipes:overview.reviews.review-16.comment',
    image: Dog16,
  },
  darlene: {
    name: 'darlene',
    owner: 'recipes:overview.reviews.review-17.owner',
    comment: 'recipes:overview.reviews.review-17.comment',
    image: Dog17,
  },
  jen: {
    name: 'jen',
    owner: 'recipes:overview.reviews.review-18.owner',
    comment: 'recipes:overview.reviews.review-18.comment',
    image: Dog18,
  },
  mallia: {
    name: 'mallia',
    owner: 'recipes:overview.reviews.review-19.owner',
    comment: 'recipes:overview.reviews.review-19.comment',
    image: Dog19,
  },
  jev: {
    name: 'jev',
    owner: 'recipes:overview.reviews.review-20.owner',
    comment: 'recipes:overview.reviews.review-20.comment',
    image: Dog20,
  },
  teresa: {
    name: 'teresa',
    owner: 'recipes:overview.reviews.review-21.owner',
    comment: 'recipes:overview.reviews.review-21.comment',
    image: Dog21,
  },
  anu: {
    name: 'anu',
    owner: 'recipes:overview.reviews.review-22.owner',
    comment: 'recipes:overview.reviews.review-22.comment',
    image: Dog22,
  },
  valerie: {
    name: 'valerie',
    owner: 'recipes:overview.reviews.review-23.owner',
    comment: 'recipes:overview.reviews.review-23.comment',
    image: Dog23,
  },
  katie: {
    name: 'katie',
    owner: 'recipes:overview.reviews.review-24.owner',
    comment: 'recipes:overview.reviews.review-24.comment',
    image: Dog24,
  }
}